exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-detail[data-v-a042a356] {\n  color: #0077fa !important;\n  cursor: pointer !important;\n}\n[data-v-a042a356] .ant-tabs-nav-scroll {\n  width: 100% !important;\n  display: -webkit-box !important;\n  display: -webkit-flex !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n[data-v-a042a356] .ant-tabs-nav {\n  display: -webkit-box !important;\n  display: -webkit-flex !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  width: 100% !important;\n}\n[data-v-a042a356] .ant-tabs-ta {\n  width: 33.33% !important;\n}\n", ""]);

// exports
